import axios from 'axios';
import {
  PORTAL_POST_LIST_REQUEST, PORTAL_POST_LIST_SUCCESS, PORTAL_POST_LIST_FAIL,
  PORTAL_POST_LIST_BY_IDS_REQUEST, PORTAL_POST_LIST_BY_IDS_SUCCESS, PORTAL_POST_LIST_BY_IDS_FAIL,
  PORTAL_POST_DETAILS_REQUEST, PORTAL_POST_DETAILS_SUCCESS, PORTAL_POST_DETAILS_FAIL,
  PORTAL_POST_CREATE_REQUEST, PORTAL_POST_CREATE_SUCCESS, PORTAL_POST_CREATE_FAIL,
  PORTAL_POST_UPDATE_REQUEST, PORTAL_POST_UPDATE_SUCCESS, PORTAL_POST_UPDATE_FAIL,
  PORTAL_POST_DELETE_REQUEST, PORTAL_POST_DELETE_SUCCESS, PORTAL_POST_DELETE_FAIL,
  PORTAL_POST_DTO_REQUEST, PORTAL_POST_DTO_SUCCESS, PORTAL_POST_DTO_FAIL,
} from '../constants/portalPostConstants';

const API_BASE_URL = '/dotnet_api/v1/portalPost';

const getAuthConfig = (token) => ({
  headers: {
    'Content-type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const formatErrorMessage = (error) => {
  if (error.response?.data?.detail) return [error.response.data.detail];
  if (error.response?.data?.message) return [error.response.data.message];
  return [error.message || 'An error occurred'];
};

export const listPortalPosts = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_LIST_REQUEST });
    const { data } = await axios.get(`${API_BASE_URL}/all`, {
      ...getAuthConfig(getState().userLogin.userInfo.token),
      params,
    });
    dispatch({ type: PORTAL_POST_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_LIST_FAIL, payload: formatErrorMessage(error) });
  }
};

export const listPortalPostsByIds = (ids) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_LIST_BY_IDS_REQUEST });
    const { data } = await axios.post(
      `${API_BASE_URL}/ids/all`,
      ids,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_LIST_BY_IDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_LIST_BY_IDS_FAIL, payload: formatErrorMessage(error) });
  }
};

export const getPortalPostDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_DETAILS_REQUEST });
    const { data } = await axios.get(
      `${API_BASE_URL}/${id}`,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_DETAILS_FAIL, payload: formatErrorMessage(error) });
  }
};

export const createPortalPostEntity = (body) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_CREATE_REQUEST });
    const { data } = await axios.post(
      API_BASE_URL,
      body,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_CREATE_FAIL, payload: formatErrorMessage(error) });
  }
};

export const updatePortalPostEntity = (id, changes) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_UPDATE_REQUEST });
    const { data } = await axios.put(
      `${API_BASE_URL}/${id}`,
      changes,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_UPDATE_FAIL, payload: formatErrorMessage(error) });
  }
};

export const deletePortalPostEntity = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_DELETE_REQUEST });
    await axios.delete(
      `${API_BASE_URL}/${id}`,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_DELETE_SUCCESS });
  } catch (error) {
    dispatch({ type: PORTAL_POST_DELETE_FAIL, payload: formatErrorMessage(error) });
  }
};

export const loadPortalPostDto = () => async (dispatch, getState) => {
  try {
    dispatch({ type: PORTAL_POST_DTO_REQUEST });
    const { data } = await axios.get(
      `${API_BASE_URL}/dto`,
      getAuthConfig(getState().userLogin.userInfo.token),
    );
    dispatch({ type: PORTAL_POST_DTO_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PORTAL_POST_DTO_FAIL, payload: formatErrorMessage(error) });
  }
};
